import Form from '@arivaa-react/components/form';

export function EditFooterBrandInfo() {
  const handleSubmit = async (values) => {
    console.log(values);
  };
  return (
    <div className="card">
      <div className="heading">
        <p className="label">Edit Brand Information</p>
      </div>
      <div className="edit-form">
        <Form
          renderForm={({ renderElement }) => {
            return (
              <div>
                <div className="item">
                  {renderElement({
                    type: 'file',
                    name: 'photoURL',
                    label: 'Select Logo',
                    required: false,
                    fileCode: 'profileImage',
                  })}
                </div>
                <div className="item">
                  {renderElement({
                    type: 'textarea',
                    name: 'about',
                    label: 'About Company',
                    required: true,
                    options: {
                      initialValue: 'Home',
                    },
                  })}
                </div>
              </div>
            );
          }}
          onSubmit={handleSubmit}
          submitButtonProps={{
            children: 'Save',
          }}
        />
      </div>
    </div>
  );
}
